import React from "react";
import { Table, TableHead, TableBody } from "@mui/material";
import PetsTableHead from "./PetsTableHead";
import PetRow from "../pages/PetRow";

function PetsTable({ data, columns, order, orderBy, onSortRequest }) {
  return (
    <Table>
      <TableHead>
        <PetsTableHead 
          columns={columns} 
          order={order} 
          orderBy={orderBy} 
          onSortRequest={onSortRequest} 
        />
      </TableHead>
      <TableBody>
        {data.map((pet) => (
          <PetRow key={pet.id} pet={pet} columns={columns} pets={data} />
        ))}
      </TableBody>
    </Table>
  );
}

export default PetsTable;